import script from "./TrainingReservations.vue?vue&type=script&setup=true&lang=js"
export * from "./TrainingReservations.vue?vue&type=script&setup=true&lang=js"

import "./TrainingReservations.vue?vue&type=style&index=0&id=54b4cc50&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-54b4cc50"]])

export default __exports__